var _mask, _g, _g2, _g3, _mask2, _g4, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 431,
    viewBox: "0 0 314 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 110,
    width: 242,
    height: 242
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 231,
    r: 121,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -43,
    y: 39,
    width: 399,
    height: 383,
    fill: "#DAEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-14.4851 367.282C-19.2884 371.933 -22 378.333 -22 385.019V388.511C-22 393.437 -20.1057 397.938 -16.9883 401.374L-15.1512 403.149C-11.6071 406.165 -6.95453 408 -1.85958 408C7.06307 408 15.6363 404.531 22.0487 398.327L101.892 321.073C102.267 320.708 102.626 320.333 102.975 319.953C111.354 310.736 110.994 296.678 101.892 287.876C97.1564 283.29 90.9477 281 84.739 281C78.5304 281 72.3217 283.29 67.5859 287.876L-14.4851 367.282Z",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.922,
    y: 118.316,
    width: 82.505,
    height: 215.684,
    rx: 6.50697,
    fill: "#1a1a1a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.918,
    y: 101,
    width: 110.261,
    height: 227.143,
    rx: 13,
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 107,
    width: 100,
    height: 215
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.273 109.403V109.491C185.273 111.941 183.402 115.043 179.098 115.043H136.228C131.923 115.043 130.053 111.941 130.053 109.491V109.403C130.053 108.27 130.053 107.112 128.024 107.112H119.467C112.317 107.112 108 111.424 108 118.568L108 310.32C108 317.464 112.317 321.776 119.467 321.776H195.77C202.921 321.776 207.238 317.464 207.238 310.32V118.568C207.238 111.424 202.921 107.112 195.77 107.112H187.302C185.273 107.112 185.273 108.27 185.273 109.403Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 235,
    x2: 145,
    y2: 235,
    stroke: "#f0f6ff",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 245,
    x2: 156,
    y2: 245,
    stroke: "#f0f6ff",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 255,
    x2: 156,
    y2: 255,
    stroke: "#f0f6ff",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 243.5,
    x2: 196.5,
    y2: 243.5,
    stroke: "#7FB5FF",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 243.5,
    x2: 179.5,
    y2: 243.5,
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 275,
    x2: 156,
    y2: 275,
    stroke: "#f0f6ff",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 285,
    x2: 156,
    y2: 285,
    stroke: "#f0f6ff",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 279.5,
    x2: 196.5,
    y2: 279.5,
    stroke: "#f0f6ff",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 279.5,
    x2: 179.5,
    y2: 279.5,
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 110.5H167",
    stroke: "#ccc",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147 110.5H148",
    stroke: "#ccc",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.384 148.897L150.689 155.678C149.107 156.225 147.611 156.952 146.224 157.834L139.941 154.909L138.921 157.101L139.941 154.909C138.605 154.288 137.018 154.655 136.091 155.8L133.378 159.149L135.348 160.744L133.378 159.149C132.451 160.294 132.422 161.923 133.308 163.1L137.549 168.736C137.013 170.256 136.644 171.856 136.465 173.51L130.217 176.699C128.904 177.368 128.216 178.845 128.548 180.281L129.517 184.48L131.987 183.91L129.517 184.48C129.848 185.916 131.114 186.942 132.587 186.968L139.558 187.094C140.438 188.504 141.477 189.803 142.65 190.966L141.208 197.769L143.688 198.295L141.208 197.769C140.903 199.21 141.618 200.675 142.942 201.32L146.816 203.21L147.927 200.932L146.816 203.21C148.14 203.856 149.734 203.517 150.682 202.389L155.207 197.003C156.011 197.095 156.827 197.142 157.654 197.142C158.481 197.142 159.297 197.095 160.101 197.003L164.627 202.389C165.575 203.517 167.168 203.856 168.493 203.21L172.366 201.32C173.691 200.675 174.405 199.21 174.1 197.769C174.1 197.769 174.1 197.769 174.1 197.769L172.658 190.966C173.832 189.803 174.871 188.504 175.75 187.094L182.721 186.968C184.194 186.942 185.46 185.916 185.791 184.48L186.761 180.281L184.291 179.711L186.761 180.281C187.092 178.845 186.404 177.368 185.092 176.699L183.94 178.956L185.092 176.699L178.843 173.51C178.664 171.855 178.296 170.256 177.759 168.736L182 163.1L179.975 161.576L182 163.1C182.886 161.923 182.857 160.294 181.93 159.149L179.96 160.744L181.93 159.149L179.217 155.8C178.29 154.655 176.703 154.288 175.367 154.909L169.084 157.834C167.697 156.952 166.201 156.225 164.619 155.678L162.924 148.897C162.924 148.897 162.924 148.897 162.924 148.897C162.567 147.468 161.282 146.465 159.809 146.465H155.499C154.026 146.465 152.741 147.468 152.384 148.897C152.384 148.897 152.384 148.897 152.384 148.897ZM172.211 176.038C172.211 183.971 165.78 190.402 157.847 190.402C149.914 190.402 143.483 183.971 143.483 176.038C143.483 168.105 149.914 161.674 157.847 161.674C165.78 161.674 172.211 168.105 172.211 176.038Z",
    fill: "#DAEAFF",
    stroke: "#DAEAFF",
    strokeWidth: 5.06968
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 75.2533,
    y: 77.6475,
    width: 163.842,
    height: 297.021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.3343,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0.728149,
    y: 0.626228,
    width: 312.641,
    height: 429.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.816047
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50.5949
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.951ba0fd5f7cb3d6a118f70a36407323.svg";
export { ForwardRef as ReactComponent };